import React from 'react';

// The Badges/B2C/B2B dropdown was removed in favour of a card-based navigation
// on the main Badges page. This now simply renders its children.
const BadgeLayout = ({ children }) => {
  return <div>{children}</div>;
};

export default BadgeLayout;
